import React, { useRef } from "react";
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import styled from "styled-components";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Gold from "../../assets/icons/gold.svg";
import Silver from "../../assets/icons/sliver.svg";
import Bronze from "../../assets/icons/brozen.svg";
import { formatDate } from "utils/formatDate";
import { getIcon } from "utils/iconsConfig";

const StyledTableContainer = styled(TableContainer)`
  background-color: transparent;
  border: 1px solid #fff;
  border-radius: 5px;
  max-height: 75vh;
  overflow: auto;
  position: relative;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

const StyledTable = styled(Table)`
  width: 100%;
  border-collapse: collapse;
  & td {
    font-size: 14px;
    font-family: "Karla";
    font-weight: 500;
    line-height: 22px;
    color: #ffffff;
    text-align: center;
    border: 1px solid #fff;
  }
  & th {
    background-color: #444444;
    font-weight: bold;
    position: sticky;
    top: 0;
    z-index: 10;
  }
`;

const StyledTableHeaderCell = styled(TableCell)`
  padding: 10px;
  font-size: 14px !important;
  font-weight: 400 !important;
  background-color: #444444;
  color: white;
  border: none !important;
  text-align: center !important;
  white-space: nowrap;
`;

const StyledTableRow = styled(TableRow)`
  border-bottom: 1px solid #fff;
  & td {
    padding: 10px;
  }
`;

const StyledTableBodyCell = styled(TableCell)`
  padding: 10px;
  text-align: center;
  white-space: nowrap;
`;

const DesignTable = ({ data, fetchNextPage, hasNextPage, isFetchingNextPage, handleOpenImageModal }) => {
  const tableRef = useRef(null);
  const limit = 15;

  const handleScroll = () => {
    const element = tableRef.current;
    if (element) {
      const { scrollTop, scrollHeight, clientHeight } = element;
      if (scrollTop + clientHeight >= scrollHeight - 10 && hasNextPage && !isFetchingNextPage) {
        setTimeout(() => fetchNextPage(), 500);
      }
    }
  };

  //stock Type
  const checkDesignClass = (stokeType) => {
    const visionTypes = {
      "Gold Class": Gold,
      "Silver Class": Silver,
      "Bronze Class": Bronze,
    };
    return visionTypes[stokeType] || Bronze;
  };

  const checkMakeType = (makeType) => {
    const makeTypes = { R: "r_labor", H: "h_labor", X: "x_labor" };
    return getIcon(makeTypes[makeType] || "default", "default");
  };

  return (
    <StyledTableContainer ref={tableRef} onScroll={handleScroll}>
      <StyledTable>
        <TableHead>
          <TableRow>
            <StyledTableHeaderCell>Sr no.</StyledTableHeaderCell>
            <StyledTableHeaderCell>Design No.</StyledTableHeaderCell>
            <StyledTableHeaderCell>Category</StyledTableHeaderCell>
            <StyledTableHeaderCell>Sub - Category</StyledTableHeaderCell>
            <StyledTableHeaderCell>Class</StyledTableHeaderCell>
            <StyledTableHeaderCell>Make</StyledTableHeaderCell>
            <StyledTableHeaderCell>D Wt</StyledTableHeaderCell>
            <StyledTableHeaderCell>D Pcs</StyledTableHeaderCell>
            <StyledTableHeaderCell>G Wt</StyledTableHeaderCell>
            <StyledTableHeaderCell>N Wt</StyledTableHeaderCell>
            <StyledTableHeaderCell>Design Date</StyledTableHeaderCell>
            <StyledTableHeaderCell>Created Date</StyledTableHeaderCell>
            <StyledTableHeaderCell>Restricted</StyledTableHeaderCell>
            <StyledTableHeaderCell>View</StyledTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.pages.flatMap((page, pageIndex) =>
            page.data.map((dataItem, index) => {
              const serialNumber = pageIndex * limit + index + 1;
              return (
                <StyledTableRow key={`${pageIndex}-${index}`}>
                  <StyledTableBodyCell>{serialNumber}.</StyledTableBodyCell>
                  <StyledTableBodyCell>{dataItem.styleCode}</StyledTableBodyCell>
                  <StyledTableBodyCell>{dataItem.category}</StyledTableBodyCell>
                  <StyledTableBodyCell>{dataItem.subCategory || "-"}</StyledTableBodyCell>
                  <StyledTableBodyCell>
                    <img src={checkDesignClass(dataItem?.stockType)} alt="star" />
                  </StyledTableBodyCell>
                  <StyledTableBodyCell>
                    <Typography>{checkMakeType(dataItem.makeType)}</Typography>
                  </StyledTableBodyCell>
                  <StyledTableBodyCell>{dataItem.diamondWt.toFixed(2)}</StyledTableBodyCell>
                  <StyledTableBodyCell>{dataItem.diamondPcs}</StyledTableBodyCell>
                  <StyledTableBodyCell>{dataItem.grossWt.toFixed(2)}</StyledTableBodyCell>
                  <StyledTableBodyCell>{dataItem.netWt.toFixed(2)}</StyledTableBodyCell>
                  <StyledTableBodyCell>{formatDate(dataItem.styleDate)}</StyledTableBodyCell>
                  <StyledTableBodyCell>{formatDate(dataItem.createDate)}</StyledTableBodyCell>
                  <StyledTableBodyCell>{dataItem.restricted ? "Yes" : "NO"}</StyledTableBodyCell>
                  <StyledTableBodyCell sx={{ cursor: "pointer" }}>
                    <RemoveRedEyeIcon onClick={() => handleOpenImageModal(dataItem.imagePath, dataItem.styleCode)} />
                  </StyledTableBodyCell>
                </StyledTableRow>
              );
            })
          )}
          {isFetchingNextPage && (
            <StyledTableRow>
              <StyledTableBodyCell colSpan={14} align="center">
                <Skeleton variant="rectangular" animation="wave" />
              </StyledTableBodyCell>
            </StyledTableRow>
          )}
        </TableBody>
      </StyledTable>
    </StyledTableContainer>
  );
};

export default DesignTable;
